import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
	checkboxControl: {
		alignItems: 'baseline',
		'& .MuiFormControlLabel-label': {
			color: '#4a4a4a',
			fontSize: 13
		}
	},
	formSection: {
		marginBottom: 25,
		'&:last-child': {
			marginBottom: 0
		}
	},
	formSectionContent: {
		marginTop: 20,
		'& .MuiCheckbox-root': {
			padding: 0,
		},
		'& .MuiFormControlLabel-root': {
			alignItems: 'flex-start'
		}
	},
	formSectionHeader: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		'@media(max-width: 900px)': {
			alignItems: 'flex-start',
			flexDirection: 'column'
		}
	},
	formSectionHeading: {
		fontWeight: 500
	},
	formSectionInput: {
		marginBottom: 25,
		width: '100%',
		'&:last-child': {
			marginBottom: 0
		}
	},
	formSectionRadio: {
		color: '#4A4A4A',
		display: 'flex',
		flexDirection: 'row',
		'& .MuiSvgIcon-root': {
			fill: theme.palette.primary.main,
			fontSize: '2.6rem'
		}
	},
	summaryContent: {
		backgroundColor: '#F5F5F5',
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: 25,
		padding: 30,
		'@media(max-width: 480px)': {
			flexDirection: 'column',
			padding: 15
		}
	},
	summaryItem: {
		width: '50%',
		marginBottom: 30,
		'&:last-child': {
			marginBottom: 0
		},
		'@media(max-width: 480px)': {
			marginBottom: 10,
			width: 'auto'
		},
		'& .capitalise': {
			textTransform: 'capitalize'
		}
	},
	summaryItemLabel: {
		color: '#A4A4A4',
		display: 'block',
		fontSize: 14
	},
	summaryItemValue: {
		color: '#4A4A4A',
		display: 'inline-block',
		fontSize: 16,
		fontWeight: 500,
		marginRight: 20,
		wordBreak: 'break-word',
		wordWrap: 'break-word',
		whiteSpace: 'pre-wrap',
	},
	summaryItemValueNone: {
		fontSize: 15,
		fontWeight: 500,
		color: '#4a4a4a'
	},
	formLabel:{
		color: '#4A4A4A',
		fontSize: '16px',
		fontStyle: 'normal',
		fontWeight: 450,
		lineHeight: '22px', /* 137.5% */
		letterSpacing: '-0.5px',
		display:'block',
		marginTop:'10px',
		marginBottom:'5px'
	}
});
